import { UTILS } from '@aksia/infrastructure';

export enum DealDynamicEnum {
  Competitive = 1,
  LimitedProcess,
  Proprietary,
}
export namespace DealDynamicEnum {
  const replace = [{ key: /([a-z])([A-Z])/g, value: '$1 $2' }];
  export const toOptions = () =>
    UTILS.UI.enumToOptions(DealDynamicEnum, replace);
}

export enum DealTypeSecondaryEnum {
  Single_Fund = 1,
  Multi_Fund,
  GP__led_CV___Single_Asset,
  GP__led_CV___Multi_Asset,
  Tender_Offer,
  Direct_Secondary,
  Fund_Restructure,
  Spin__out,
  Strip_sale,
}
export namespace DealTypeSecondaryEnum {
  const replace = [{ key: /_/g, value: ' ' }];
  export const toOptions = () =>
    UTILS.UI.enumToOptions(DealTypeSecondaryEnum, replace);
}

export enum AssetModeEnum {
  Editing = 'isEditing',
  Linking = 'isLinking',
}
